'use es6';

import { Component } from 'react';
import curry from 'transmute/curry';
import createHocName from './createHocName';

/**
 * Returns a decorated component which renders the original component
 * by passing props **replaced by** mapFn(props).
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default curry((mapFn, Subject) => {
  var _class;
  return _class = class Decorated extends Component {
    constructor(...args) {
      super(...args);
      this.render = () => {
        const mappedProps = mapFn(this.props);
        return /*#__PURE__*/_jsx(Subject, Object.assign({}, mappedProps));
      };
    }
  }, _class.displayName = createHocName('mapProps', Subject), _class;
});